import { render, staticRenderFns } from "./CartCloserIcon.vue?vue&type=template&id=68e442d0&"
import script from "./CartCloserIcon.vue?vue&type=script&lang=js&"
export * from "./CartCloserIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports